import React, { useEffect } from "react";
import logo from "../Assets/images/avatar_.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faMicrophoneSlash,
} from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { IRequestListResponse } from "../@types/VideoCallTypes";
import { Spinner } from "react-bootstrap";

type Props = {
  remoteUsers: any;
  sessionDetail: any;
  screenView: boolean;
  selectedUser: number | "local";
  onPressSelectedUser: (val: "local" | number) => void;
  activeTab: any;
  requestRightsRevoke: (userId: number) => Promise<void>;
  loading: boolean;
};

const ManyRemoteUserVideos = (props: Props) => {
  useEffect(() => {
    props.remoteUsers.forEach((user: any) => {
      if (user.videoTrack) {
        user.videoTrack.play(`remote-video-${user.uid}`);
      }
    });
    console.log("remoteUsers===>", props.remoteUsers, props.sessionDetail);
  }, [props.remoteUsers, props.selectedUser]);

  return (
    <div>
      {props.remoteUsers.length !== 0 ? (
        <>
          {props.remoteUsers.map((user: any) => {
            const studentProfile = props.sessionDetail.users?.find(
              (profile: any) => profile.userId == user.uid
            );
            return (
              <div
                className={`new__members ${
                  user.uid === props.selectedUser ? "selectedmemb_video" : ""
                }`}
              >
                <div
                  className="member__video"
                  onClick={() => props.onPressSelectedUser(user.uid)}
                >
                  <div key={user.uid}>
                    <video
                      id={`remote-video-${user.uid}`}
                      autoPlay
                      playsInline
                      width="100%"
                      height="40%"
                    />
                    <div className="new--user--name">
                      {studentProfile?.userName}
                    </div>
                  </div>

                  {user.uid === props.selectedUser &&
                    props.screenView &&
                    user.videoEnabled && (
                      <div className="new_user__avatar">
                        <div className="user__avatar">
                          <img
                            src={
                              studentProfile?.profilePicture
                                ? studentProfile?.profilePicture
                                : logo
                            }
                            alt="User Avatar"
                            width="100"
                            height="100"
                          />
                        </div>
                        <div className="new_user__name">
                          {studentProfile?.userName}
                        </div>
                      </div>
                    )}

                  {/* {!user.videoEnabled && (
                    <div className="new_user__avatar">
                      <div className="user__avatar">
                        <img
                          src={
                            studentProfile?.profilePicture
                              ? studentProfile?.profilePicture
                              : logo
                          }
                          alt="User Avatar"
                          width="100"
                          height="100"
                        />
                      </div>
                      <div className="new_user__name">
                        {studentProfile?.userName}
                      </div>
                    </div>
                  )} */}
                </div>

                {props.screenView && (
                  <div className="member__cntrls">
                    {props.loading ? (
                      <div className="member_mute_icon member_status_text">
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      </div>
                    ) : (
                      <div
                        className="member_mute_icon member_status_text"
                        onClick={() => props.requestRightsRevoke(user.uid)}
                      >
                        Revoke
                      </div>
                    )}
                    {user.audioEnabled ? (
                      <>
                        <div className="member_mute_icon">
                          <FontAwesomeIcon
                            color="#fff"
                            style={{ zIndex: "1" }}
                            className="icon white-icon"
                            icon={faMicrophone as IconProp}
                          />
                        </div>
                      </>
                    ) : (
                      <div className="member_mute_icon">
                        <FontAwesomeIcon
                          color="#fff"
                          style={{ zIndex: "1" }}
                          className="icon"
                          icon={faMicrophoneSlash as IconProp}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </>
      ) : (
        <>
          {/* {props.selectedUser !== "local" && (
            <h1 className="waiting__user">Waiting For User to join</h1>
          )} */}
        </>
      )}
    </div>
  );
};

export default ManyRemoteUserVideos;
